import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import apiService from "../services/api";
import LessonCard from "../components/LessonCard";
import PageShell from "../components/PageShell";

/** A topic's article list. */
export default function TopicPage() {
  const { topicSlug } = useParams();
  const navigate = useNavigate();
  const [lessons, setLessons] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    setStatus("loading");
    apiService
      .listTopicLessons(topicSlug)
      .then((data) => {
        setLessons(data);
        setStatus("ready");
      })
      .catch((err) => {
        // Private topic while signed out → send to sign-in, then back here.
        if (err?.response?.status === 401) {
          navigate("/signin", {
            state: { from: `/articles/topic/${topicSlug}` },
            replace: true,
          });
          return;
        }
        setStatus("error");
      });
  }, [topicSlug, navigate]);

  const topicName = lessons[0]?.topic_name;

  return (
    <PageShell>
      <Link
        to="/articles"
        className="text-sm text-sky-400 transition hover:text-sky-300"
      >
        ← All topics
      </Link>

      <h1 className="mt-4 text-3xl font-bold tracking-tight text-slate-100">
        {topicName || topicSlug}
      </h1>

      {status === "loading" && (
        <p className="mt-6 text-slate-500">Loading articles…</p>
      )}
      {status === "error" && (
        <p className="mt-6 text-rose-400">Topic not found.</p>
      )}

      {status === "ready" && (
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {lessons.map((lesson) => (
            <LessonCard key={lesson.slug} lesson={lesson} />
          ))}
        </div>
      )}
    </PageShell>
  );
}
